// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"eae95367","348":"9fe14d9b","571":"5191e484","924":"a710cf96"}[chunkId] + ".chunk.js";
};